<template>
  <div id="auth" class=" grey lighten-5">
   <div class="card">
          <div class="card-logo">
             <img :src="biggerLogo" width="50px" alt="">
          </div>
          <div class="card-content">
            <div class="row">
           <!--    <div class="col s12 title-col">
                Login
              </div> -->
              <div class="input-field col s12">
                <i class="material-icons grey-text text-darken-2 prefix">
                  account_circle
                </i>
                <label for="login">User/Email</label>
                <input 
                :disabled="locked" 
                v-model="user.email" type="text" name="login" id="login">
              </div>
              <div class="input-field col s12">
                <i class="material-icons grey-text text-darken-2 prefix">
                  lock
                </i>
                <label for="password">Password</label>
                <input 
                :disabled="locked"
                  v-on:keyup.enter="_login()"
                  v-model="user.password" type="password" name="password" id="password">
              </div>
              <div class="col s12">
                <label for="remember">
                  <input id="remember" type="checkbox" v-model="remember">
                    <span>Stay Signed in</span>
                </label>
               
              </div>
            </div>
             
        <div class="col s12 ">
          <button 
          :disabled="locked"
          @click="_login()" class=" btn z-depth-custom-1 btn-large indigo accent-2 rounded waves-effect" style="width:92%;  margin-left:3%;">
            Sign In

              <div 
              v-bind:class="[locked ? 'active' : '']"
              class="preloader-wrapper small ">
                <div class="spinner-layer spinner-white-only">
                  <div class="circle-clipper left">
                    <div class="circle"></div>
                  </div><div class="gap-patch">
                    <div class="circle"></div>
                  </div><div class="circle-clipper right">
                    <div class="circle"></div>
                  </div>
                </div>
              </div>

          </button>
          </div>
          <div class="clear"></div>
        </div>
        </div>
  </div>
</template>

<script>
// @ is an alias to /src
import M from 'materialize-css'
import auth from '@/services/authService.js'
import biggerLogo from '@/assets/bigger-logo.png'
export default {
  name: 'home',
  components: { },
  data(){
    return {
      user:[],
      locked:false,
      clickCount:0,
      remember:false,
      biggerLogo,
    }
  },
  mounted(){
    if (localStorage.getItem('rememberMe')) {
       this.remember = true
       this.user.email = localStorage.getItem('userLogin')
       this.user.password = localStorage.getItem('userPass')

    }

    setTimeout(() => {
       M.updateTextFields();
    }, 100);
  },
  watch:{
    clickCount:function(nV){
     if(nV > 3) {
      M.Toast.dismissAll();
      M.toast({html:'Too many attempts try again later',displayLength:15000}, )
       setTimeout(() => {
         this.locked = false
       }, 30000);
     }
    }
  },
  methods:{
    $_clickCountMonitor(){
      !this.clickCount
      ? this.clickCount = 1
      : this.clickCount = this.clickCount + 1
    },
    _login(){
      this.$_clickCountMonitor()
      this.locked = true
      const err_message = (index) => {
        M.Toast.dismissAll();
        index 
        ? M.toast({html:`Invalid username or password`})
        : M.toast({html:`awww ish gone wronng`})
        this.locked = false
      }
      if (this.remember) {
        localStorage.setItem('userLogin', this.user.email)
        localStorage.setItem('userPass',this.user.password)
        localStorage.setItem('rememberMe', true)
      }
      else {
        try{
            localStorage.removeItem('userLogin'), localStorage.removeItem('rememberMe')
            }
        catch(e){
          return e
        }
      }
      auth.generateToken(this.user.email, this.user.password)
      .then((result)=>{
        auth.getUserInfo(result.user_email)
        .then(res=>{
          localStorage.setItem('user', JSON.stringify(res.data))
          this.$store.commit('SET_USER', res.data)
          this._go(res.data)
          this.clickCount < 4 
          ? this.locked = false
          : false
        })
        .catch(err =>{
          if(err)
           this.clickCount < 4 
           ? err_message(0) 
           : false
        })
      })
      .catch((err)=>{
        if(err)
        this.clickCount < 4 
        ? err_message(1)
        : false
      })
    },
    _go(user){
      let userDep = user.acf.departments
  
      let goRoute = (department) => {/* 
        console.log(department) */
        return department  === 'records' 
        ?  {name:'records' }
        : department === 'it'
          ? {name:'transcripts'}
          : department === 'sec'
            ? {name:'transcripts'}
            : department === 'jud'
              ? {path:'/stats'}
              : {path:'/home'}
      }
     
      
      auth.validate()
      .then((result)=>{
        if(result)
        this.$router.push(  goRoute(userDep))
      })
    }
  }
}
</script>
<style lang="scss" scoped>
#auth {
    min-height: calc(100Vh - 56px);
    position: relative;
  @media screen and (min-width:1024px) {
    width: calc(100% - 300px);
    margin-left:300px;
  }
  .card {
    border-radius:8px; 
    overflow: hidden; max-width: 440px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    position: absolute;
    min-width: 360px;

    box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.02), 0px 4px 5px 0px rgba(0, 0, 0, 0.04), 0px 1px 10px 0px rgba(0, 0, 0, 0.02);
    .card-logo {
      text-align: center;
      padding: 15px 0px 23px;
      position: relative;
    /*   border-bottom: .75px solid #ececec; */
        &::after {
          content: 'Eastern Caribbean Supreme Court';
          position: absolute;
          text-align: center;
          width: 100%;
          z-index: 99;
          bottom: 7px;
          left: 0;
          letter-spacing: 1px;
          text-transform: uppercase;
          font-weight: 500;
          font-size: 13px;
      }
      img {
        width: 80px;
      }
    }
  .card-content {
    padding-top:12px;
  }
  }
  .title-col {
    font-size: 24px;
  }
  label[for="remember"] {
    line-height: 42px;
  }
  [type="checkbox"]:checked+span:not(.lever):before {
    border-left: 2px solid transparent;
    border-right: 2px solid #5070f0;
    border-bottom: 2px solid #5070f0;
}
.to-vertical-center {
    transform: translateY(35%);
}
button {
  .preloader-wrapper {
    position: absolute;
    position: absolute;
    top: 8px;
    right: 17px;
  }
}
}
</style>
